import { useGlobalInstallationConfig, useLatestAppVersionDetails } from '@atlassian/mpac-api-client';
export const useLatestVersionDetailsAndInstallationConfig = _ref => {
  let {
    appKey,
    environmentKey,
    cloudId = '',
    skipGlobalInstallationConfig,
    skipLatestVersionAppDetails,
    gqlGatewayUrl
  } = _ref;
  const {
    latestVersionAppDetailsResult,
    latestVersionAppDetailsLoading,
    latestVersionAppDetailsError
  } = useLatestAppVersionDetails({
    appKey,
    environmentKey,
    skip: skipLatestVersionAppDetails,
    gqlGatewayUrl
  });
  const {
    globalInstallationConfigResult,
    globalInstallationConfigLoading,
    globalInstallationConfigError
  } = useGlobalInstallationConfig({
    cloudId,
    skip: skipGlobalInstallationConfig,
    gqlGatewayUrl
  });
  return {
    latestVersionAppDetailsResult,
    latestVersionAppDetailsLoading,
    latestVersionAppDetailsError,
    globalInstallationConfigResult,
    globalInstallationConfigLoading,
    globalInstallationConfigError
  };
};